export default "__VITE_ASSET__48607eab__$_?nuxt_component=async&nuxt_component_name=SvgoWoocommerce__"